import { Provider } from '@angular/core';

import { FORMAT_SPECIFICATION_SERVICE, FORMAT_STORE } from '../model';
import { ASSIGNMENTS_SERVICE, AssignmentsService } from '../services/assignments.service';
import { BASE_FORMAT_SERVICE, BaseFormatsService } from '../services/base-formats.service';
import { FORMATS_CONTEXT, FormatsContext } from '../services/formats-context-aware';
import { FORMAT_NAVIGATOR_SERVICE, FormatsNavigatorService } from '../services/formats-navigator.service';
import { FORMAT_SERVICE, FormatsService } from '../services/formats.service';
import { SpecificationDefinitionsService } from '../services/specification-definitions.service';
import { SpecificationsService } from '../services/specifications.service';
import { BaseFormatStore, FormatStore } from '../store';

export function formatsRouteProviders(context: FormatsContext, options: { includeAssignmentsService?: boolean } = {}): Provider[] {
  const providers: Provider[] = [
    {
      provide: FORMATS_CONTEXT,
      useValue: context
    },
    {
      provide: FORMAT_SERVICE,
      useClass: FormatsService
    },
    {
      provide: FORMAT_SPECIFICATION_SERVICE,
      useClass: SpecificationsService
    },
    {
      provide: FORMAT_STORE,
      useExisting: FormatStore
    },
    {
      provide: FORMAT_NAVIGATOR_SERVICE,
      useClass: FormatsNavigatorService
    },
    FormatStore
  ];

  if (options.includeAssignmentsService) {
    providers.push({
      provide: ASSIGNMENTS_SERVICE,
      useClass: AssignmentsService
    });
  }

  return providers;
}

export function baseFormatsRouteProviders(context: FormatsContext): Provider[] {
  return [
    {
      provide: FORMATS_CONTEXT,
      useValue: context
    },
    {
      provide: BASE_FORMAT_SERVICE,
      useClass: BaseFormatsService
    },
    {
      provide: FORMAT_SPECIFICATION_SERVICE,
      useClass: SpecificationDefinitionsService
    },
    {
      provide: FORMAT_STORE,
      useExisting: BaseFormatStore
    },
    {
      provide: FORMAT_NAVIGATOR_SERVICE,
      useClass: FormatsNavigatorService
    },
    BaseFormatStore
  ];
}
